// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2LU9b","chart":"styles_chart__yVa6R","xAxisLabel":"styles_xAxisLabel__NeCub"};